// src/views/Employees/Modal/EditAttendanceSessionModal.jsx
import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { employeeActions } from "../redux/actions/employee.actions";
import { modeConstants } from "../constants";

export default function EditAttendanceSessionModal({
  show,
  onHide,
  mode,
  onHideSessionModal
}) {
  const dispatch = useDispatch();
  const initialData = useSelector((s) => s.employeeReducer.sessionFormData); // should contain session_id, check_in_at, check_out_at
  const isAdd = mode === modeConstants.ADD_MODE;
  const isEdit = mode === modeConstants.UPDATE_MODE;
  const isView = mode === modeConstants.VIEW_MODE;
  const title = isAdd ? "Add Attendance" : "Edit Attendance";
  const userId = useSelector((s) => s.employeeReducer.userId);
  const id = useSelector((s) => s.employeeReducer.id);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      session_id: "",
      user_id: "",
      check_in_at: "",
      check_out_at: "",
    },
  });

  // DB stores either "2024-07-01 09:00:00" (full datetime) or just time "09:00:00" (if showing date-based sessions).
  // datetime-local inputs require "YYYY-MM-DDTHH:MM" format.
  const toLocalInput = (val, parentDate) => {
    if (!val) return "";
    const cleanVal = String(val).trim();
    
    // If it contains a date already (e.g., "2024-07-01 09:00:00")
    if (cleanVal.length > 8) {
      return cleanVal.replace(" ", "T").slice(0, 16);
    }
    
    // If it is just a time (e.g., "09:00:00" or "09:00"), prepend parentDate
    if (parentDate) {
      return `${parentDate}T${cleanVal.slice(0, 5)}`;
    }
    
    return "";
  };

  useEffect(() => {
    if (show && initialData) {
      reset({
        session_id:   initialData.id           || "",
        user_id:      initialData.user_id       || "",
        check_in_at:  toLocalInput(initialData.check_in_at, initialData.parent_date),
        check_out_at: toLocalInput(initialData.check_out_at, initialData.parent_date),
      });
    }
  }, [show, initialData, reset]);

  const onSubmit = (values) => {
    if (isAdd) {
      values = {...values, user_id: id}
      dispatch(employeeActions.addSession(values, userId, onHide));
    } else {
      dispatch(employeeActions.updateSession(values, userId, onHide, onHideSessionModal));
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input type="hidden" {...register("session_id")} />
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="mb-3">
                <label htmlFor="check_in_at" className="form-label">
                  Check-In Time
                </label>
                <input
                  id="check_in_at"
                  type="datetime-local"
                  className="form-control"
                  {...register("check_in_at", {
                    required: "Check-in is required",
                  })}
                  max={new Date().toISOString().slice(0, 16)}
                  required
                />
                {errors.check_in_at && (
                  <small className="text-danger">
                    {errors.check_in_at.message}
                  </small>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="mb-3">
                <label htmlFor="check_out_at" className="form-label">
                  Check-Out Time
                </label>
                <input
                  id="check_out_at"
                  type="datetime-local"
                  className="form-control"
                  {...register("check_out_at")}
                  max={new Date().toISOString().slice(0, 16)}
                  required
                />
                {errors.check_out_at && (
                  <small className="text-danger">
                    {errors.check_out_at.message}
                  </small>
                )}
              </div>
            </div>
          </div>

          {/* footer */}
          <div className="d-flex justify-content-end footer-modal">
            <Button
              variant="outline-secondary"
              onClick={onHide}
              className="btn-footer"
            >
              {isView ? "Close" : "Cancel"}
            </Button>
            {!isView && (
              <Button type="submit" variant="success" className="btn-footer">
                {isEdit ? "Save Changes" : "Create"}
              </Button>
            )}
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
